// Chakra imports
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import PieChart from "components/charts/PieChart";
import React from "react";

export default function RevenueChart(props) {
  const { revenueByPaymentMethod = {} } = props;
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const cardColor = useColorModeValue("white", "navy.700");
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );

  // Convert revenue by payment method to chart data
  const paymentMethodLabels = Object.keys(revenueByPaymentMethod);
  const paymentMethodValues = Object.values(revenueByPaymentMethod);
  const totalRevenue = paymentMethodValues.reduce((sum, val) => sum + (val || 0), 0);

  const pieChartData = paymentMethodValues;
  const pieChartOptions = {
    labels: paymentMethodLabels.map(method => {
      const methodMap = {
        mobile_money: 'Mobile Money',
        bank_transfer: 'Bank Transfer',
        cash: 'Cash',
        card: 'Card',
      };
      return methodMap[method] || method.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }),
    colors: ["#4318FF", "#6AD2FF", "#EFF4FB", "#39B8FF"],
    chart: {
      width: "50px",
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    hover: { mode: null },
    plotOptions: {
      donut: {
        expandOnClick: false,
        donut: {
          labels: {
            show: false,
          },
        },
      },
    },
    fill: {
      colors: ["#4318FF", "#6AD2FF", "#EFF4FB", "#39B8FF"],
    },
    tooltip: {
      enabled: true,
      theme: "dark",
    },
  };

  return (
    <Card p='20px' align='center' direction='column' w='100%' {...props}>
      <Flex
        px={{ base: "0px", "2xl": "10px" }}
        justifyContent='space-between'
        alignItems='center'
        w='100%'
        mb='8px'>
        <Text color={textColor} fontSize='md' fontWeight='600' mt='4px'>
          Revenue by Payment Method
        </Text>
      </Flex>

      <PieChart
        h='100%'
        w='100%'
        chartData={pieChartData}
        chartOptions={pieChartOptions}
      />
      <Card
        bg={cardColor}
        flexDirection='row'
        boxShadow={cardShadow}
        w='100%'
        p='15px'
        px='20px'
        mt='15px'
        mx='auto'>
        {paymentMethodLabels.map((method, index) => {
          const value = paymentMethodValues[index] || 0;
          const percentage = totalRevenue > 0 ? ((value / totalRevenue) * 100).toFixed(0) : 0;
          const colors = ["#4318FF", "#6AD2FF", "#EFF4FB", "#39B8FF"];
          const methodMap = {
            mobile_money: 'Mobile Money',
            bank_transfer: 'Bank Transfer',
            cash: 'Cash',
            card: 'Card',
          };
          const methodName = methodMap[method] || method.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
          
          return (
            <Flex key={method} direction='column' py='5px' me={index < paymentMethodLabels.length - 1 ? '20px' : '0'}>
              <Flex align='center'>
                <Box h='8px' w='8px' bg={colors[index % colors.length]} borderRadius='50%' me='4px' />
                <Text
                  fontSize='xs'
                  color='secondaryGray.600'
                  fontWeight='700'
                  mb='5px'>
                  {methodName}
                </Text>
              </Flex>
              <Text fontSize='lg' color={textColor} fontWeight='700'>
                {percentage}%
              </Text>
            </Flex>
          );
        })}
      </Card>
    </Card>
  );
}

